import React, {Component} from "react";
import * as R from "ramda";
import {
    fetchData,
    getInitialData,
    getInitialFilterData,
    getInitialSearchData,
    getPageConfig,
    getTableConfig,
    parseFilterData,
} from "../service";
import {mapToObjectDDL, removeNullFields} from "../../../../common/mapper";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import InventoryUnitTable from "./InventoryUnitTable";
import InventoryPageDetail from "./InventoryPageDetail";
import InventoryPageStock from "./InventoryPageStock";
import InventoryPageFilter from "./InventoryPageFilter";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import Api from "../../../../../Services/Api";
import SimplePrintTable from "../../../../../modules/popup/SimplePrintTable";
import SimpleInput from "../../../../../modules/SimpleInput";
import ErrorAction from "../../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import InventoryUnitPrint from "../components/modals/InventoryUnitPrint";
import { fetchDataAsync } from "../../../../../Services/Utils";
import { saveAs } from "file-saver";

class InventoryPage extends Component {
    constructor(props) {
        super(props);
        this.tableConfig = getTableConfig(this.props.type);
        this.pageConfig = getPageConfig(this.props.type);
        this.initialData = getInitialData(this.props.type)
        this.initialFilterData = getInitialFilterData(this.props.type);
        this.initialSearch = getInitialSearchData(this.props.type)
        this.state = {
            loading: false,
            filterModalVisible: false,
            detailModalVisible: false,
            unitStockModalVisible: false,
            printModalVisible: false,
            selectedData: null,
            filterData: this.initialFilterData,
            search: this.initialSearch,
            dataTable: [],
            dataCabang: [],
            selectedCabangPrint: null,
            inventoryUnitPrintVisible: false,
            pagination: {
                count: 0,
                limit: 5,
                page: 1,
                orderBy: "id",
                sort: "ASC",
            }
        };
    }

    componentDidMount() {
        this.fetchDataCabang();
    }

    componentDidUpdate = async (prevProps, prevState, snapshot) => {
        if (!R.equals(this.state.search.kodeCabang, prevState.search.kodeCabang)) {
            this.handleTriggerLoading();
            await fetchData(
                this.props.type,
                this.setState.bind(this),
                {
                    paramFilters: removeNullFields(parseFilterData(this.props.type, this.state.search)),
                    limit: this.state.pagination.limit,
                    page: 1
                }
            );
            this.handleClearForm();
            this.handleTriggerLoading();
        }
    }

    handleModalDetailVisibility = (index) => {
        this.setState((prevValue) => ({
            ...prevValue,
            selectedData: {
                ...prevValue.dataTable[index],
                kodeCabang: this.state.search.kodeCabang ? this.state.search.kodeCabang.value : null
            },
            detailModalVisible: !prevValue.detailModalVisible,
        }));
    };

    handleModalUnitStocklVisibility = (index) => {
        this.setState((prevValue) => ({
            ...prevValue,
            selectedData: {...prevValue.dataTable[index]},
            unitStockModalVisible: !prevValue.unitStockModalVisible,
        }));
    };

    handleModalFilterVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            selectedData: this.initialData,
            filterModalVisible: !prevState.filterModalVisible,
        }));
    };

    handleSubmitFilter = async () => {
        this.handleTriggerLoading();
        this.setState({
            pagination: {
                page: 1,
                limit: 5,
                orderBy: "id",
                sort: "ASC",
            }
        },async ()=>{
        await fetchData(
            this.props.type,
            this.setState.bind(this),
            {
                paramFilters: {
                    ...removeNullFields(parseFilterData(this.props.type, this.state.filterData)),
                    kodeCabang: [this.state.search.kodeCabang.value],
                },
                limit: this.state.pagination.limit,
                page: 1,
            }
        );
        this.handleClearSearch();
        this.handleModalFilterVisibility();
        this.handleTriggerLoading();
        })
    };

    handleSubmitSearch = async () => {
        this.handleTriggerLoading();
        await fetchData(
            this.props.type,
            this.setState.bind(this),
            {
                paramFilters: removeNullFields(parseFilterData(this.props.type, this.state.search)),
                limit: this.state.pagination.limit,
                page: 1,
            }
        );
        this.handleClearForm();
        this.handleTriggerLoading();
    }

    handleInventoryUnitPrintVisibility = () => {
        this.setState((prev) => ({
            ...prev,
            inventoryUnitPrintVisible: !prev.inventoryUnitPrintVisible,
            selectedCabangPrint: null
        }));
    }

    handlePrint = async () => {
        const { type } = this.props;
        const obj = {
            ksu: "KSU",
            hadiah: "HADIAH",
            otherItem: "BARANG LAIN"
        };

        this.handleTriggerLoading();

        const selectedCabang = this.state.selectedCabangPrint?.map(item => item.value);

        let args = {};
        let asyncFn = null;

        if (type === "hadiah") {
            asyncFn = Api.create("NAGAMAS_TRANSACTION_FILE").generateReportExcelInventoryGift;
            args = {
                kodeCabang: selectedCabang
            };
        } else if (type === "otherItem") {
            asyncFn = Api.create("NAGAMAS_TRANSACTION_FILE").generateReportExcelInventoryOtherItem;
            args = {
                listKodeCabang: selectedCabang
            };
        } else {
            asyncFn = Api.create("NAGAMAS_TRANSACTION_FILE").cetakInventoryMainPage;
            args = {
                paramFilters: {
                    kodeCabang: selectedCabang
                }
            };
        }

        const res = await fetchDataAsync({
            asyncFn,
            menuName: `Inventory ${obj[type]}`,
            setError: this.props.setError,
            args
        });

        if (res.ok) {
            const blob = new Blob([res.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            saveAs(blob, `INVENTORY ${obj[type]}.xlsx`);
        }

        this.handleTriggerLoading();
};


    handleFilterValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
            },
        }));
    };

    handleValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                [name]: value,
            },
        }));
    };

    handleClearForm = () => {
        this.setState((prevValue) => ({...prevValue, filterData: this.initialFilterData}));
    };

    handleClearSearch = () => {
        this.setState((prevState) => ({
            ...prevState,
            search: {
                ...prevState.search,
                ...this.initialSearch
            },
        }));
    };

    handleChangePage = async (page, limit, callback) => {
        this.handleTriggerLoading();
        this.setState(callback);

        const filterRequest = removeNullFields(parseFilterData(this.props.type, {
            ...this.state.filterData,
            kodeCabang: this.state.search.kodeCabang
        }))
        const searchRequest = removeNullFields(parseFilterData(this.props.type, this.state.search))

        let paramFilters;
        if (!R.isEmpty(filterRequest)) {
            paramFilters = {...filterRequest};
        } else {
            paramFilters = {...searchRequest};
        }

        await fetchData(
            this.props.type,
            this.setState.bind(this),
            {
                paramFilters: paramFilters,
                page: page,
                limit: limit
            }
        );

        this.handleTriggerLoading();
    }

    handleChangeRowsPerPage = async (page, limit, callback) => {
        this.handleTriggerLoading();
        this.setState(callback);

        const filterRequest = removeNullFields(parseFilterData(this.props.type, {
            ...this.state.filterData,
            kodeCabang: this.state.search.kodeCabang
        }))
        const searchRequest = removeNullFields(parseFilterData(this.props.type, this.state.search))

        let paramFilters;
        if (!R.isEmpty(filterRequest)) {
            paramFilters = {...filterRequest};
        } else {
            paramFilters = {...searchRequest};
        }

        await fetchData(
            this.props.type,
            this.setState.bind(this),
            {
                paramFilters: paramFilters,
                page: page,
                limit: limit
            }
        );
        this.handleTriggerLoading();
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchDataCabang = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
            if (res.ok) {
                let filteredData = res.data.data.filter(
                    item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
                );

                if (filteredData.length != 0) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        dataCabang: filteredData,
                        search: {
                            ...prevValue.search,
                            kodeCabang: mapToObjectDDL(filteredData[0].namaDealer, filteredData[0].kodeCabang),
                        }
                    }));
                }
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    handleSelectCabangPrint = (value) =>{
        this.setState({ selectedCabangPrint: value })
    }

    render() {
        return (
            <>
                <FlexView style={{justifyContent: "space-between"}} className="margin-bottom-5px margin-top-5px">
                    <FlexView vAlignContent="center">
                        <SimpleDDL
                            id="select_options_nama_cabang"
                            box="search"
                            name="kodeCabang"
                            containerclassname="width width-250px"
                            placeholder="Nama cabang hak akses"
                            menuPosition="fixed"
                            options={
                                this.state.dataCabang.map(
                                    item => mapToObjectDDL(item.namaDealer, item.kodeCabang)
                                )
                            }
                            value={this.state.search.kodeCabang}
                            onChange={(value, {name}) => this.handleValueChange(name, value)}
                        />
                    </FlexView>
                    <FlexView vAlignContent="center">
                        <p className="margin-left-25px margin-bottom-20px width width-280px"
                           style={{textAlign: "right"}}
                        >
                            {this.pageConfig.home.searchGrid.label}
                        </p>
                        <SimpleInput
                            id="input_search"
                            type="text"
                            name={this.pageConfig.home.searchGrid.name}
                            containerclassname="margin-left-5px margin-bottom-20px"
                            value={this.state.search[this.pageConfig.home.searchGrid.name]}
                            onChange={({target}) =>
                                this.handleValueChange(target.name, target.value)
                            }
                        />
                        <SimpleButton
                            styles={{width: "unset", marginBottom: "15px", marginLeft: "unset"}}
                            icon={<i className={"fa fa-search"}></i>}
                            onClick={this.handleSubmitSearch}
                        />
                        <SimpleButton
                            onClick={this.handleModalFilterVisibility}
                            styles={{width: "unset", marginBottom: "15px"}}
                            icon={<i className={"fa fa-qrcode"}></i>}
                        />
                    </FlexView>
                </FlexView>

                <InventoryUnitTable
                    tableConfig={this.tableConfig}
                    data={this.state.dataTable}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    pagination={this.state.pagination}
                    actionButtons={
                        (tableMeta) => {
                            const row = this.state.dataTable[tableMeta.rowIndex];
                            const hideEye = (this.props.type === "hadiah" && row.qr === false) || (this.props.type === "otherItem" && row.barcode === false);
                            return (
                                <FlexView vAlignContent="center" style={{gap: "15px"}}>
                                     {!hideEye && (
                                       <SimpleButton
                                         category="action_button"
                                         icon={
                                           <i
                                             style={{ fontSize: 20, color: "red" }}
                                             className="fa fa-lg fa-eye"
                                           ></i>
                                         }
                                         onClick={() =>
                                           this.handleModalDetailVisibility(tableMeta.rowIndex)
                                         }
                                       />
                                     )}
                                    {/* <SimpleButton
                                        category="action_button"
                                        icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-lg fa-eye"></i>}
                                        onClick={() => this.handleModalDetailVisibility(tableMeta.rowIndex)}
                                    /> */}
                                    <SimpleButton
                                        category="action_button"
                                        icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-lg fa-clipboard"></i>}
                                        onClick={() => this.handleModalUnitStocklVisibility(tableMeta.rowIndex)}
                                    />
                                </FlexView>
                            )
                        }
                    }
                    additionalButtons={
                        <FlexView vAlignContent="center">
                            <SimpleButton
                                onClick={() => this.handleInventoryUnitPrintVisibility()}
                                text={"Print"}
                            />
                        </FlexView>
                    }
                />

                {this.state.detailModalVisible && (
                    <InventoryPageDetail
                        setError={this.props.setError}
                        type={this.props.type}
                        pageConfig={this.pageConfig}
                        selectedData={this.state.selectedData}
                        visible={this.state.detailModalVisible}
                        onClickClose={this.handleModalDetailVisibility}
                    />
                )}

                {this.state.unitStockModalVisible && (
                    <InventoryPageStock
                        {...this.props}
                        kodeCabang={this.state.search?.kodeCabang?.value}
                        pageConfig={this.pageConfig}
                        selectedData={this.state.selectedData}
                        visible={this.state.unitStockModalVisible}
                        onClickClose={this.handleModalUnitStocklVisibility}
                    />
                )}

                {this.state.filterModalVisible && (
                    <InventoryPageFilter
                        type={this.props.type}
                        kodeCabang={this.state.search.kodeCabang}
                        pageConfig={this.pageConfig}
                        filterData={this.state.filterData}
                        visible={this.state.filterModalVisible}
                        onSubmit={this.handleSubmitFilter}
                        onValueChange={this.handleFilterValueChange}
                        onClearForm={this.handleClearForm}
                        onClickClose={this.handleModalFilterVisibility}
                    />
                )}

                {this.state.printModalVisible && <SimplePrintTable onClearPrint={this.handlePrint}/>}
                {this.state.inventoryUnitPrintVisible && (
                  <InventoryUnitPrint
                    visible={this.state.inventoryUnitPrintVisible}
                    dataCabang={this.state.dataCabang}
                    selectedCabang={this.state.selectedCabang}
                    handleSelectCabang={this.handleSelectCabangPrint}
                    onPrint={this.handlePrint}
                    onClickClose={this.handleInventoryUnitPrintVisibility}
                  />
                )}
                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(InventoryPage);